import { Button } from '@querodelivery/uni-react';
import { TableEmptyState } from '@/_components/table-empty-state/table-empty-state';
import styles from './delivery-detail-error-state.module.scss';

interface DeliveryDetailErrorStateProps {
  onRetry: () => void;
}

export function DeliveryDetailErrorState({
  onRetry,
}: DeliveryDetailErrorStateProps) {
  return (
    <TableEmptyState
      title="Não foi possível carregar a entrega"
      description="Tente novamente em alguns instantes."
      action={
        <Button
          type="button"
          variant="outline"
          className={styles.action}
          onClick={onRetry}
        >
          Tentar novamente
        </Button>
      }
    />
  );
}
